import {
  CascadiaControlProps,
  CascadiaJsonFormContext,
  withCascadiaControlProps,
} from "@certn/forms";
import { useContext } from "react";

import { CustomQuestionnaireControl } from "./CustomQuestionnaireControl";
import { CustomQuestionnaireSummaryControl } from "./CustomQuestionnaireSummaryControl";

function InternalCustomQuestionnaireControl(props: CascadiaControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <CustomQuestionnaireSummaryControl />;
  }

  return <CustomQuestionnaireControl {...props} />;
}

InternalCustomQuestionnaireControl.displayName = "CustomQuestionnaireControl";
export const CustomQuestionnaireControlRenderer = withCascadiaControlProps(
  InternalCustomQuestionnaireControl
);
